<!--template的内容-->
<template>
  <div class="mask">
    <div class="message-popup">
	  <div class="title">
		  <div>账号绑定提示</div>
	  </div>
	  <div class="body">
		  <slot class="body">{{ message }}</slot>
	  </div>
	  <div class="active">
		  <el-button  type="primary" @click="closeMessagePopup">确定</el-button>
	  </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'MessagePopup',
    data () {
        return {
            message: '' // 弹窗显示的内容
        }
    },
    methods: {
        closeMessagePopup () {
            this.$destroy(true)
            this.$el.parentNode.removeChild(this.$el)
        }
    },
    mounted () {

    }
}
</script>

<style scoped>
.message-popup {
		max-width: 80%;
    width: 400px;
    height: 200px;
    border: 1px solid #ccc;
		padding: 10px 20px;
    background-color: #fff;
		position: fixed;
		z-index: 66666666;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 4px;
		line-height: 24px;
		font-size: 16px;
		color:#2a2a2a;
}
	.close-message-popup{
		text-align: right;
	}
	.mask{
		width: 100vw;
		height: 100vh;
		left: 0;
		top: 0;
		z-index: 200;
		background-color: rgba(0, 0, 0, .4);
		position: fixed;
	}
	.title{
		height: 40px;
	}
	.body{
		height: 120px;
	}
	.active{
		text-align: center;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/MessagePopup/messagePopup.vue